<template>
  <section data-test="filter-staff-section">
    <h4 class="text-base font-normal leading-none text-theme-33">
      อพม.
    </h4>
    <div class="mt-2">
      <v-select
        data-test="volunteer-select"
        id="volunteer-select"
        :loading="volunterrListLoading"
        v-model="modelValueComputed"
        :options="volunteerList"
        :clearable="true"
        placeholder="กรุณาเลือก อพม."
        :appendToBody="true"
        :disabled="disableSelect"
        :getOptionLabel="volunteerList => `${volunteerList.title} ${volunteerList.name} ${volunteerList.surname}`"
      >
        <template #selected-option="{ title ,name ,surname }">
          <div style="display: flex; align-items: baseline">
            <span>{{ title }} {{ name }} {{ surname }}</span>
          </div>
        </template>
        <template #option="{ title ,name ,surname }">
            <h3 style="margin: 0">{{ title }} {{ name }} {{ surname }}</h3>
        </template>
        <template #no-options="">
          <p class="text-sm font-normal text-gray-500">
            ไม่พบ อพม. ที่ค้นหา
          </p>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
        </template>
      </v-select>
      <!-- <select
        id="staff-select"
        class="form-select form-select-sm"
        v-model="modelValueComputed"
      >
        <option
          :value="null"
          disabled
          selected
        >
          กรุณาเลือก อพม.
        </option>
        <option>เจ้าหน้าที่1</option>
        <option>เจ้าหน้าที่2</option>
        <option>เจ้าหน้าที่3</option>
      </select> -->
    </div>
  </section>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted, onUnmounted } from "vue";
import TreeSelect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import Swal from "sweetalert2";
import { useStore } from "vuex";
import axios from "axios";

const props = defineProps({
  modelValue: Object,
});
const emits = defineEmits(["update:modelValue"]);

const localStore = window.localStorage;
const store = useStore();
const disableSelect = ref(false);
const value = ref(null);
const cm_ID = ref(null);
const volunteerList = ref([]);
const volunterrListLoading = ref(false);

onMounted(() => {
  checkUserRole();
  // getVT_ID();
});

const options = reactive([
  {
    id: 1,
    label: "เจ้าหน้าที่1",
  },
  {
    id: 2,
    label: "เจ้าหน้าที่2",
  },
  {
    id: 3,
    label: "เจ้าหน้าที่3",
  },
]);

const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(evt) {
    emits("update:modelValue", evt);
  },
});

// const volunteerListComputed = computed(() =>
//   volunteerList.value.map((item) => ({
//     ...item,
//     fullname: `${item.title}${item.name} ${item.surname}`,
//   }))
// );

const checkUserRole = async () => {
  const userRoleCode = store.getters["userAuth/getUserRoleCode"];
  if (userRoleCode === "cm") {
    cm_ID.value = JSON.parse(
      JSON.stringify(store.getters["userAuth/getUsername"])
    );
    disableSelect.value = false;
    // emits("updateCm",cm_ID.value)
    // await store.dispatch("householdFilter/setCM", cm_ID.value);
    // await store.dispatch("familyFilter/setCM", cm_ID.value);
    // await store.dispatch("memberFilter/setCM", cm_ID.value);
    getVT_LIST();
  } else {
    getVT_ID()
  }
};
const getVT_ID = () => {
  const painData = localStore.getItem("volunteerData");
  const data = JSON.parse(painData);
  disableSelect.value = true;
  if (!data) {
    store.dispatch("householdFilter/setVolunteer", data);
    store.dispatch("familyFilter/setVolunteer", data);
    store.dispatch("memberFilter/setVolunteer", data);
  }
};

const getVT_LIST = async () => {
  const url = `${process.env.VUE_APP_BASE_API}volunteer/getVolunteer`;
  const body = {
    cm_uid: JSON.parse(JSON.stringify(cm_ID.value)),
  };
  const res = await axios.post(url, { ...body }).catch(() => {
    Swal.fire({
      icon: "warning",
      text: "ระบบผิดพลาด",
    });
  });
  if (res.status === 200) volunteerList.value = res.data;
};
</script>
